<div class="pageContainer refreshed-ui">
    <div class="spd-wrapper">
        <div class="sp-breadcrumb-nav-bar">
            <a data-id="solution-participation-details" routerLink="/solution-participation-details"  [queryParams]="{tab: 'solution-group-view'}" class="link-blue">
                Solution Participation - Solution Group View
            </a>
            <div class="chevron"><img src="assets/chevron-right.svg" alt="chevron-right" /></div>
            <a data-id="solution-participation-groupBy-products" [routerLink]="['/solution-participation-groupBy-products']" [queryParams]="{ groupBy: 'products', solutionGroup: solutionGroupName }"class="link-blue">
                Product Details
            </a>
            <div class="chevron"><img src="assets/chevron-right.svg" alt="chevron-right" /></div>
            <a data-id="solution-participation-location-drilldown " class="last-breadcrumb link-blue">
                {{productName! | capitalize}}
            </a>
        </div>

        <div class="exporttable-btn-block">
            <div class="exporttable-btn" (click)="exportAllToExcel()">
                <div class="export-icon">
                 <span *ngIf="!isDownloadingFile">
                    <img src="assets/export-table-icon.svg" alt="export-table-icon" />
                </span>
                <span *ngIf="isDownloadingFile">
                    <span class="loader-sm"></span>
                </span>
                </div>
                <span>Export Table</span>
            </div>
        </div>
        <div class="search-pagination-row">
            <div id="sol-loc-toggle-pagination" class="sol-loc-toggle-pagination">
                <mat-paginator #paginator [pageSize]="10" [pageSizeOptions]="[5, 10, 20, 50]" [length]="totalRecords"
                (page)="onPageChange($event)" aria-label="Select page"></mat-paginator>
            </div>
        </div>

        <section class="product-details-table" id="product-details-table" *ngIf="!isLoading; else loader">

            <!-- Table header section -->
            <div class="header-box">
                <div class="product common-p">Product</div>
                <div class="accountNumber common-p">Account Info</div>
                <div class="sales common-p">
                    Product Sales Summary
                    <span class="sort-arrow" data-id="sort-arrow-sales" (click)="toggleSortDirection('sales')">
                        <img class="sort-arrow-img" [ngClass]="{'up': sortDirections['sales'] == 'asc', 'down': sortDirections['sales'] == 'desc' }" src="assets/blue-arrow.svg" alt="sort-arrow" />
                    </span>
                </div>
                <div class="cases common-p">
                    Cases
                    <span class="sort-arrow" data-id="sort-arrow-cases"  (click)="toggleSortDirection('cases')">
                        <img class="sort-arrow-img" [ngClass]="{'up': sortDirections['cases'] == 'asc', 'down': sortDirections['cases'] == 'desc' }" src="assets/blue-arrow.svg" alt="sort-arrow" />
                    </span>
                </div>
                <div class="exportall-checkbox common-p">
                    <mat-checkbox color="primary" (change)="selectAllRows()" [checked]="allRowsSelected">Export All</mat-checkbox>
                </div>
            </div>

            <ng-container *ngIf="data?.products?.length; else noData">
                <ng-container *ngFor="let product of productDataPaginated; let i = index">
                    <div class="product-table-row" [id]="'product-table-row-' + i">
                        <!-- Product block -->
                        <div class="product-block p-20">
                            <div class="product-name text-700">{{product.productName}}</div>
                            <div><span class="sku-text">SKU: </span>{{product.productCode}}</div>
                        </div>
                        <!-- Account Info block -->
                        <div class="account-block p-20">
                            {{ product.accountInfo[0].accountNumber}}
                            <div class="account-name">{{product.accountInfo[0].accountName | capitalize}}</div>
                        </div>
                        <!-- Product Sales Summary block -->
                        <div class="sales-block p-20">
                            <p class="sales-amount">{{ product.totalSalesAmount.value | currency:currencyCode:'symbol':'1.0-0' }}</p>
                        </div>
                        <!-- Cases block -->
                        <div class="cases-block p-20">
                            <p class="cases-amount">{{ product.totalSalesQuantity | number}}</p>
                        </div>

                        <!-- Export button block -->
                        <div class="export-block p-20">
                            <div class="export-checkbox">
                                <mat-checkbox  color="primary" class="checkbox" [checked]="rowSelection[(paginator.pageIndex * paginator.pageSize) + i]"
                                #checkBox (change)="onCheckboxChange(checkBox,product,i)">Export</mat-checkbox>
                            </div>
                        </div>

                    </div>
                </ng-container>
            </ng-container>

            <!-- Display 'No Data' when there are no locations on load -->
            <ng-template #noData>
                <div class="Loader">
                    No Data
                </div>
            </ng-template>

            <!-- Display 'Location not found' when search results are empty -->
            <ng-template [ngIf]="totalRecords == 0">
                <div class="not-found">
                    Location not found.
                </div>
            </ng-template>
        </section>

        <ng-template #loader>
            <div class="Loader">
                Loading...
                <loader></loader>
            </div>
        </ng-template>
    </div>
</div>
